module.exports = __webpack_public_path__ + "img/quexing.e11242ec.png";